import { call, put, select, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { ERROR_ACTIONS } from '../reducers/error';
import { v4 as uuid } from 'uuid';
import { buildHeaders } from './confirm';
import { getRequest } from '~redux/selectors';
import { PaymentMethodWithRedirect } from '@airwallex/airwallex-payment-elements';
import { ExtendElementType, sendEvent, POST_EVENTS } from '~components/events';
import { getAirwayUrl, sendRequestLog, getOS } from '~components/utils';
import { deviceOSMapping } from '~components/constant';

interface AttemptRedirectPayload {
  id: string;
  componentName: ExtendElementType;
  method: PaymentMethodWithRedirect;
}

interface FlowObj {
  flow: 'webqr' | 'mweb';
  os_type?: 'android' | 'ios';
}

export const getPaymentFlowObj = () => {
  const os = getOS();
  const flowObj: FlowObj = {
    flow: 'webqr',
  };
  if (os && deviceOSMapping[os] && ['android', 'ios'].includes(deviceOSMapping[os])) {
    flowObj.flow = 'mweb';
    flowObj.os_type = deviceOSMapping[os];
  }

  return flowObj;
};

export function* createPaymentAttemptAsync(data: { type: string; payload: AttemptRedirectPayload }) {
  yield put({ type: ERROR_ACTIONS.SET, payload: {} });
  try {
    const { id, componentName, method } = data.payload || {};
    const request = yield select(getRequest);
    const reqPath = `${getAirwayUrl()}/payment_intents/${id}/confirm`;

    const reqPayload = {
      request_id: uuid(),
      payment_method: {
        type: method,
        [method]: getPaymentFlowObj(),
      },
    };
    const reqHeader = buildHeaders(request);
    sendRequestLog({ componentName, reqPath, reqHeader, reqPayload, origin: request.origin });
    const {
      data: { next_action: nextAction },
    } = yield call([axios, 'post'], reqPath, reqPayload, reqHeader);
    sendEvent(
      {
        type: componentName,
        code: POST_EVENTS.onLogResponse,
        path: reqPath,
        res: data,
        header: {
          ...reqHeader,
          'Awx-Tracker': null,
        },
      },
      request.origin,
    );

    if (nextAction && nextAction.type === 'redirect') {
      if (data.payload.componentName === 'hpp') {
        window.location.href = nextAction.url;
      } else {
        sendEvent(
          {
            type: componentName,
            code: POST_EVENTS.onRedirect,
            redirectPayload: {
              method,
              redirectUrl: nextAction.url,
            },
          },
          request?.origin,
        );
      }
    } else {
      yield put({ type: ERROR_ACTIONS.SET, payload: 'REDIRECT_CONFIRM_FAILED' });
    }
  } catch (error) {
    yield put({ type: ERROR_ACTIONS.SET, payload: error?.response?.data || 'REDIRECT_CONFIRM_FAILED' });
  }
}

export function* watchCreateAttemptRedirectAsync() {
  yield takeLatest('AWX_CHECKOUT_ATTEMPT_REDIRECT_ASYNC', createPaymentAttemptAsync);
}
